import { BentoCard } from './BentoCard';
import styles from './MobileComponent.module.css';

export const MobileComponent = ({ className }: { className?: string }) => {
  return (
    <div className={className ? `${styles.root} ${className}` : styles.root}>
      <div className={styles.head}>
        <h2>A deep dive on your health</h2>
        <p>
          Get 100+ biomarkers across aging, heart health, energy, disease
          prevention and more. Track the progression of your health over time
          and take action with personalized insights.
        </p>
      </div>

      <div className={`${styles.sleepItemsContainer} u-hide-scrollbar`}>
        <div className={styles.items}>
          <BentoCard
            gridColumn="1 / span 6"
            gridRow="2 / 3"
            title={'Book at-home test'}
            alt="Book at-home test"
            textColor="#ffffff"
            bgGradient="radial-gradient(136.15% 136.15% at 50% -36.15%, #4664FF 0%, #0E0E0E 81.42%);"
            textAlign="left"
            image="web_v2/blood-vision/bento/book-test-map-2.png"
            parentType="flex"
          />

          <BentoCard
            gridColumn="7 / span 5"
            gridRow="2 / 3"
            title="AI clinician report and action plan"
            alt="AI clinician report and action plan"
            textColor="#ffffff"
            bgGradient="radial-gradient(220.18% 190.6% at -14.64% -67.01%, #4664FF 0%, #121212 76.17%), #0E0E0E;"
            textAlign="left"
            image="web_v2/blood-vision/bento/AI-clinician-perspective.png"
            colReverse
            parentType="flex"
          />

          <BentoCard
            gridColumn="1 / span 4"
            gridRow="3 / 4"
            title={
              <>
                Two
                <br />
                advanced
                <br />
                tests a year
              </>
            }
            alt="Two advanced tests a year"
            textColor="#ffffff"
            image="web_v2/blood-vision/bento/two_advanced_tests.png"
            textAlign="left"
            bgGradient="radial-gradient(500.26% 100% at 50% 100%, rgba(70, 100, 255, 0.00) 12.07%, #0E0E0E 90%), #0E0E0E;"
            parentType="flex"
          />

          <BentoCard
            gridColumn="5 / span 7"
            gridRow="3 / 4"
            title="Blood Age: Your longevity, measured"
            alt="Blood Age: Your longevity, measured"
            textColor="#ffffff"
            bgColor="#0E0E0E"
            textAlign="left"
            image="web_v2/blood-vision/bento/blood-age-3.png"
            parentType="flex"
          />

          <BentoCard
            gridColumn="1 / span 5"
            gridRow="4 / 5"
            alt="For a more quieter space"
            textColor="#ffffff"
            textAlign="left"
            bgColor="#0E0E0E"
            boxShadow="0px 0px 174px 0px rgba(70, 100, 255, 0.60) inset;"
            parentType="flex"
            centerImage="web_v2/blood-vision/bento/hsa-fsa.png"
          />

          <BentoCard
            gridColumn="6 / span 6"
            gridRow="4 / 5"
            title={
              'Beyond standard testing (20 unique clinically relevant markers)'
            }
            alt="Beyond standard testing (20 unique clinically relevant markers)"
            textColor="#ffffff"
            textAlign="left"
            bgGradient="radial-gradient(286.33% 237.62% at 93.25% 224.26%, #4664FF 0%, #0E0E0E 81.11%), #0E0E0E;"
            image="web_v2/blood-vision/bento/unique-tests-2.png"
            parentType="flex"
          />
        </div>
        {/* <div className="items">
            <div className="item recovery">
              <div className="content">
                <h4>ROOM SCORE</h4>
                <h3>Your space, decoded</h3>
              </div>
            </div>
            <div className="item temperature">
              <div className="content">
                <h4>Environment contributors</h4>
                <h3>
                  The anatomy of
                  <br />
                  your environment
                </h3>
                <div className="img-container">
                  <Image
                    src={'web_v2/ring-buy/recovery/svg/tempRes.svg'}
                    fill
                    alt="temperature-img"
                    className="temperature-img"
                  />
                </div>
              </div>
            </div>
            <div className="item hrv">
              <div className="content">
                <h4>
                  {t('ring.bentoRecoverySection.hrvCard.title')}
                </h4>
                <h3>
                  {t('ring.bentoRecoverySection.hrvCard.subtitleA')}
                  <br />{' '}
                  {t('ring.bentoRecoverySection.hrvCard.subtitleB')}
                </h3>
                <div className="img-container">
                  <Image
                    src={'web_v2/ring-buy/recovery/png/asset.png'}
                    fill
                    alt="contributor-img"
                    className="contributorImg"
                  />
                </div>
              </div>
            </div>
            <div className="item stress">
              <div className="content">
                <h4>
                  {t('ring.bentoRecoverySection.stressCard.title')}
                </h4>
                <h3>
                  {t('ring.bentoRecoverySection.stressCard.subtitleA')}{' '}
                  {t('ring.bentoRecoverySection.stressCard.subtitleB')}
                </h3>
              </div>
            </div>
          </div> */}
      </div>
    </div>
  );
};
